// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"1ab4eeee","201":"cd8d614d","291":"0ac43d7a","392":"85a6839d","499":"5b086fb8","673":"742ddd24","717":"d8d0575f","728":"d4b8cfac","778":"cd20d761","970":"8262b4c0"}[chunkId] + ".chunk.js";
};